import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { StyledButton } from "@insite/mobius/Clickable";
import { FormFieldStyle, FormInputWrapper } from "@insite/mobius/FormField";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

export interface ProductDetailsViewStyles {
    container?: GridContainerProps;
    productImgContainerColumnGridItem?: GridItemProps;
    productActionColumnGridItem?: GridItemProps;
    productInfoColumnGridItem?: GridItemProps;
}

export const viewStyles: ProductDetailsViewStyles = {
    container: {
        css: css`
            margin-top: 30px;
        `,
    },

    productInfoColumnGridItem: {
        width: [12, 12, 12, 12, 12],
        css: css`
            [data-test-selector="productDetails_specifications"] {
                margin: 30px 0 !important;
                width: 100% !important;
                padding: 0;
                border: 1px solid rgba(2, 126, 148, .06);
                background-color: #fff;
                [data-test-selector="sectionPanel"] span{
                    padding: .5625rem .625r
                }
            }
            [data-test-selector="productDetails_specifications"] {
                [data-test-selector="sectionHeader"], button {
                    background-color: #254351;
                    color: #fff;
                    span {
                        color: #fff;
                    }
                }
            }
            [data-test-selector="productDetails_attributes"] {
                border: 1px solid #d5d5d5;
                padding: 0.5em;
                p {
                    display: flex;
                }
                span${TypographyStyle} {
                    padding: .5625rem .625rem;
                    line-height: 1.25rem;
                    width: 20%;
                }
                span {
                    padding: .5625rem .625rem;
                    line-height: 1.25rem;
                    width: 80%;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                        span${TypographyStyle} {
                            padding: .5625rem .625rem;
                            line-height: 1.25rem;
                            width: 50%;
                        }
                        span {
                            padding: .5625rem .625rem;
                            line-height: 1.25rem;
                            width: 50%;
                        }
                        `,
                        css`
                        span${TypographyStyle} {
                            padding: .5625rem .625rem;
                            line-height: 1.25rem;
                            width: 50%;
                        }
                        span {
                            padding: .5625rem .625rem;
                            line-height: 1.25rem;
                            width: 50%;
                        }
                        `,
                        css`
                        `,
                        css`
                        `,
                        css`
                        `,
                ])}
            }
        `
    },
    productImgContainerColumnGridItem: {
        width: [12, 12, 8, 8, 8],
        css: css`
            div:first-child { 
                min-height: 0px;
            }
            [data-test-selector="brandLink"] {
                ${TypographyStyle} {
                    font-family: "Franklin Gothic Book";
                    font-size: 15px;
                    font-weight: 400;
                    color: #2d2d2d;
                }
            }
            [data-test-selector="productDetails_mainImage"] {
                width: 100%;
                padding-right: 10px;
                max-width: 190px;
            }
            [data-test-selector="productDetails_productDescription"] {
                font-family: "Franklin Gothic Demi";
                color: #2d2d2d;
                font-size: 28px;
                font-weight: 600;
            }
        `
    },
    productActionColumnGridItem: {
        width: [12, 12, 4, 4, 4],
        css: css`
            [data-test-selector="product_qtyOrdered-label"]{
                display: none;
            }
            ${FormFieldStyle}{
                margin: 0 !important;
                ${FormInputWrapper} {
                    margin: 0 !important;
                }
            }
            [data-test-selector="quoteRequiredText"] {
                color: #fff;
                margin-right: 2px;
            }
            ${StyledButton} {
                ${IconWrapper} {
                    color: #fff;
                }
            }
            [data-test-selector="product_qtyOrdered"] {
                border: 3px solid #02788c !important;
                background-color: #fff;
                max-width: 90%;
                height: 50px;
                padding: 4px 10px 4px 20px;
                line-height: 22px;
                box-shadow: none;
                font-family: "Franklin Gothic Book";
                font-size: 15px;
                font-weight: 400;
                color: #2d2d2d !important;
            }
            [data-test-selector="addProductToCart"] {
                font-size: 18px;
                height: 50px;
                padding: 10px;
                text-transform: uppercase;
                font-weight: 700;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        [data-test-selector="addProductToCart"] {
                            margin-top: 10px;
                        }
                    `,
                    css`
                        [data-test-selector="addProductToCart"] {
                            margin-top: 10px;
                        }
                    `,
                    css`
                        
                    `,
                    css`
                        
                    `,
                    css`
                        
                    `,
            ])}
            [data-test-selector="productDetails_addToListWrapper"] {
                margin-top: 10px;
            }
            [data-test-selector="productDetails_shareLinkWrapper"] {
                margin-top: 10px;
                [data-test-selector="productShareLink"] span{
                    color: #fff;
                    font-family: 'Franklin Gothic Heavy';
                    font-weight: 800;
                }
            }
            [data-test-selector="productDetails_addToList"] {
                color: #02788c !important;
                border: 3px solid #02788c;
                padding: 10px;
                text-transform: uppercase;
                background-color: #fff;
                font-weight: 700;
                width: 100%;
                display: flex;
                justify-content: center;
                position: relative;
                font-size: 17px;
                span {
                    color: #02788c !important;
                }
                :before {
                    content: "";
                    
                }
            }
            [data-test-selector="availabilityMessageWrapper"] {
                margin-bottom: 10px;
                ${GridOffset} {
                    align-items: center;
                    ${GridItemStyle} {
                        flex-basis: fit-content;
                        max-width: fit-content;
                        margin-right: 10px;
                    }
                }
            }
        `
    },
};

const styles = viewStyles;

const ProductDetailsView: React.FC<WidgetProps> = props => {
    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.productImgContainerColumnGridItem} data-test-selector="productDetails_productImgContainerItem">
                <Zone contentId={props.id} zoneName="Content0"/>
            </GridItem>

            <GridItem {...styles.productActionColumnGridItem} data-test-selector="productDetails_productActionItem">
                <Zone contentId={props.id} zoneName="Content1"/>
            </GridItem>

            <GridItem {...styles.productInfoColumnGridItem} data-test-selector="productDetails_productInfoItem">
                <Zone contentId={props.id} zoneName="Content2"/>
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: connect()(ProductDetailsView),
    definition: {
        displayName: "View",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
